import {useTypedSelector} from "./selectors.utils";
import MessageModel from "../../models/responses/message.model";

// Ledger
export const useLedgerListSelector = () => useTypedSelector<MessageModel[]>(state => state.ledger.ledgerList);
export const useRecentUserItemsSelector = () => useTypedSelector<MessageModel[]>(state => state.ledger.recentUserItems);

